import {config} from "@/constants/config";
import type {AdminUser} from "@/types/auth.types";
import {create} from "zustand";

interface AuthState {
  user: AdminUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  login: (token: string, user: AdminUser, refreshToken: string) => void;
  logout: () => void;
  hydrate: () => void;
}

const SESSION_KEY = config.sessionKey;

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,

  login: (token, user, refreshToken) => {
    const session = {token, user, refreshToken};
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    set({user, accessToken: token, refreshToken, isAuthenticated: true});
  },

  logout: () => {
    sessionStorage.removeItem(SESSION_KEY);
    set({user: null, accessToken: null, refreshToken: null, isAuthenticated: false});
  },

  hydrate: () => {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return;
    try {
      const session = JSON.parse(raw) as {token: string; user: AdminUser; refreshToken?: string};
      set({
        user: session.user,
        accessToken: session.token,
        refreshToken: session.refreshToken ?? null,
        isAuthenticated: true,
      });
    } catch {
      sessionStorage.removeItem(SESSION_KEY);
    }
  },
}));
